import { useLocationQuery } from '@hooks/useLocationQuery';

export const useGetUrlParameter = (parameter: string) => {
  const locationQuery = useLocationQuery();
  return locationQuery.get(parameter);
};
